export const getEntryFixedDecimalScale = ({
  fixedDecimalScale,
  shouldShowRawWhileFocused,
  isFocused,
}) => !!fixedDecimalScale && !(shouldShowRawWhileFocused && isFocused);

export const getEntryInputProps = ({ inputProps, onBlur, onFocus }) => ({
  ...inputProps,
  onBlur,
  onFocus,
});
